import { ReactNode } from "react";
import { FormControl, InputLabel, Select, FormHelperText } from "@mui/material";
import { SelectChangeEvent } from "@mui/material/Select";

const SelectDropdown = ({
    label,
    width,
    height,
    dropdownContent,
    value,
    setValue,
    error, // ✅ Added error prop
    helperText, // ✅ Added helperText prop
}: {
    label?: string;
    width?: number;
    height?: number;
    dropdownContent: ReactNode[];
    value: string;
    setValue: (value: string) => void;
    error?: boolean; // ✅ Error state
    helperText?: string; // ✅ Error message
}) => {
    const handleChange = (event: SelectChangeEvent) => {
        setValue(event.target.value as string);
    };

    return (
        <FormControl fullWidth error={error}> {/* ✅ Show error state */}
            {label && <InputLabel>{label}</InputLabel>}
            <Select
                renderValue={(value) => value}
                label={label || ""}
                value={value}
                onChange={handleChange}
                variant="outlined"
                sx={{
                    textAlign: "left",
                    width: width ?? null,
                    height: height ?? null,
                }}
                MenuProps={{
                    anchorOrigin: {
                        vertical: "top",
                        horizontal: "right",
                    },
                    transformOrigin: {
                        vertical: "top",
                        horizontal: "right",
                    },
                    MenuListProps: {
                        style: {
                            minWidth: 250,
                            paddingTop: 0,
                        },
                    },
                    PaperProps: {
                        style: {
                            zIndex: 1500, // Adjust the z-index here
                        },
                    },
                }}
            >
                {dropdownContent.map((item: ReactNode) => item)}
            </Select>
            {error && helperText && <FormHelperText>{helperText}</FormHelperText>} {/* ✅ Show validation message */}
        </FormControl>
    );
};

export default SelectDropdown;
